import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getNotificationRequest, getNotificationRequestError, getNotificationRequestSuccess } from "../../slices/Notification/GetNotificationSlice";

export const GetNotificationApi = (data) => async (dispatch) => {
    try {
        dispatch(getNotificationRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getNotification,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getNotificationRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getNotificationRequestError(_error));
            });
    } catch (error) {
    }
};
